import { useEffect, useRef, useState } from 'react';
import BackButton from '../common/backButton';
import { FaCrown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { getDataWithToken, postData, postDataWithToken } from '../api/api';
import { HOME, BUDDYGAMEUPDATE, BUDDYGAMEUPDATESTATUS, BUDDYGAMEBYID, GAMEUPDATESTATUS } from '../helpers/Constant';
import { Oval } from 'react-loader-spinner';
import { FaCheck } from 'react-icons/fa'
import { IoMdCopy } from 'react-icons/io';
import { getUserInfo , getUserType} from '../utils/common';
import { useTranslation } from 'react-i18next';
import { GrFormNext } from 'react-icons/gr';
import VoiceChat from './VoiceChat';

function BuddyTournamentJoin() {
    const { t } = useTranslation();
    const [buddyCode, setBuddyCode] = useState('');
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [userGameIsCompleted, setUserGameIsCompleted] = useState(false);
    const [gameTitle, setGameTitle] = useState('');
    const playerId = localStorage.getItem('joinPlayerId');
    const groupGameId = localStorage.getItem('groupGameId');
    const inputRef = useRef(null);
    const navigate = useNavigate();
    const userData = getUserInfo();
    const userType = getUserType();
    
    const [playersCount, setPlayersCount] = useState(0);
    const [isCompleted, setIsCompleted] = useState();
    const [isWaiting, setIsWaiting] = useState(false);
    const [buddyComplete, setIsBuddyComplete] = useState(false);

    const joinBuddyId = localStorage.getItem('joinGameId');
    const [lastGameLiveCall, setLastGameLiveCall] = useState(0);


    useEffect(() => {
        async function playerData() {
            try {

                if (joinBuddyId) {
                    const joinPlayer = await getDataWithToken(BUDDYGAMEBYID + joinBuddyId);
                    if (joinPlayer) {
                        if (joinPlayer.status == "422") {
                            navigate("/")
                        }

                        var users = joinPlayer.users;
                        setGameTitle(joinPlayer.game.title);
                        if (users) {
                            const highestPoint = Math.max(
                                ...users
                                    .filter(user => user.status === 'Ready')
                                    .map(user => user.burnedCal)
                            );

                            const updatedUsers = users.map(user => ({
                                ...user,
                                highest: user.status === 'Ready' && user.burnedCal === highestPoint,
                            }));

                            const me = updatedUsers.find(u =>
                                (u.user?.toString() === userData?._id)
                            );
                            setUserGameIsCompleted(me?.status === 'Completed');

                            if (userData) {
                                users.forEach((user) => {
                                    if (user.user === userData._id && user.status === 'Ready') {
                                        setUserGameIsCompleted(true);
                                    }
                                });
                            } else if (userType === 'guest_user') {
                                let joinPlayerId = localStorage.getItem('joinPlayerId')
                                users.forEach((user) => {
                                    if (user._id === joinPlayerId && user.status === 'Ready') {
                                        setUserGameIsCompleted(true);
                                    }
                                });
                            } 
                            setUsers(updatedUsers);
                            setBuddyCode(joinPlayer.code);
                            setPlayersCount(updatedUsers.length);
                        }
                    } else {
                        setUsers([]);
                        setBuddyCode('');
                    }
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
            }
        }
        playerData();

        const intervalId = setInterval(playerData, 3000);
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    useEffect(() => {
        let intervalId;
    
        if (isWaiting) {
            intervalId = setInterval(async () => {
                try {
                    if (joinBuddyId) {
                        const response = await getDataWithToken(BUDDYGAMEBYID + joinBuddyId);
                       const playerData = response.users;
                       const allComplete = playerData.every(p => p.status === "Completed");
                       const player = playerData.find(user => user._id === playerId);

                       if (player && player.status === 'Completed') {
                           setIsBuddyComplete(true)
                       } 
                        if (allComplete) {
                           const completedStatus = {
                               buddyGameId: joinBuddyId,
                               isCompleted: true
                           }

                            setUsers(playerData);
                            setLoading(false);
                            setIsCompleted(true);
                            setIsWaiting(false)
                            setUserGameIsCompleted(true);
                            localStorage.removeItem("joinBuddyId");
                            await postDataWithToken(BUDDYGAMEUPDATE, completedStatus);
                        }
                    }
                } catch (error) {}
            }, 1000);
        }
    
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [isWaiting, joinBuddyId]);


    const handleReady = async () => {
        // Group Status Update
        const userStatusData = {
            buddyGameId: joinBuddyId,
            user: {
                id: playerId,
                status: 'Ready'
            }
        };
        await postData(BUDDYGAMEUPDATESTATUS, userStatusData);
    }

    // const burnedCalories = [350, 350, 345];

    const handleGoBurn = async () => {

        if (userType && userType !== "guest_user") {
            var data = {
                "gameId": groupGameId,
                "status": 'Playing'
            }
            await postDataWithToken(GAMEUPDATESTATUS, data);
        }

        var gameName = document.getElementById('gameTitle').value;

        let playerName;

        if (userType && userType !== 'guest_user') {
            playerName = userData.fname + '_' + userData.lname;
        } else {
            playerName = localStorage.getItem('playerName');
        }
        window.location.href = `uniwebview://openMultiplayerGame?name=${gameName}&room=${buddyCode}&playerName=${playerName}`;
    }

    // End of the Game
    window.onGameClosed = async function (calories, time, score, heartbeat, accuracy) {
        handleGameClosed(calories, time, score, heartbeat, accuracy);
    };

    window.onGameLive = async function (calories, time, score, heartbeat, accuracy) {
        handleGameLive(calories, time, score, heartbeat, accuracy);
    };

    const handleGameClosed = async (calories, time, score, heartbeat, accuracy) => {
        try {
            // Group Status Update
            var data = {
                "gameId": groupGameId,
                "status": 'Online'
            }
            await postDataWithToken(GAMEUPDATESTATUS, data);

            const payloadBuddyData = {
                buddyGameId: joinBuddyId,
                users: {
                    id: userType === 'guest_user' ? playerId : userData._id,
                    burnedCal: calories,
                    time : time,
                    score: score,
                    heartbeat : heartbeat,
                    accuracy: accuracy,
                    status: "Completed"
                }
            }
            const buddyPlayerUpdateScore = await postDataWithToken(BUDDYGAMEUPDATE, payloadBuddyData);
            setUserGameIsCompleted(true);
            const playerData = buddyPlayerUpdateScore.data['users'];
            const allComplete = playerData.every(player => player.status === "Completed");

            if (allComplete) {
                setUsers(playerData);

                await postDataWithToken(BUDDYGAMEUPDATE, {
                    buddyGameId: joinBuddyId,
                    isCompleted: true
                });

                setLoading(false);
                setIsWaiting(false);
                setIsCompleted(true);
                setUserGameIsCompleted(true);
                localStorage.removeItem("joinBuddyId");
            } else {
                setIsWaiting(true);
            }
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }

    const handleGameLive = async (calories, time, score, heartbeat, accuracy) => {
        const now = Date.now();
        if (now - lastGameLiveCall < 10000) {
            return;
        }
        setLastGameLiveCall(now);
        try {


            const payloadBuddyData = {
                buddyGameId: joinBuddyId,
                users: {
                    id: userData._id,
                    burnedCal: calories,
                    time : time,
                    score: score,
                    heartbeat : heartbeat,
                    accuracy: accuracy,
                    status: "Playing"
                }
            }
            
            await postDataWithToken(BUDDYGAMEUPDATE, payloadBuddyData);
            sendPlayerScores();
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }

    
    const sendPlayerScores = async () => {
        try {
            const joinGameId = localStorage.getItem('joinGameId');
            if (!joinGameId) {
                return { error: "No active lobby found." };
            }

            const response = await getDataWithToken(BUDDYGAMEBYID + joinGameId);
            if (!response || !response.users) {
                return { error: "Failed to fetch player data." };
            }

            const players = response.users
                .map((user, index) => ({
                    id: user._id,
                    name: user.name || `Player_${index}`,
                    score: user.burnedCal || 0,
                }))
                .sort((a, b) => b.score - a.score);

            const data = {
                scores: players
            };
            const encodedData = encodeURIComponent(JSON.stringify(data));
            window.location.href = `uniwebview://updatePlayerScores?scores=${encodedData}`;
            
        } catch (error) {
            console.error("Error fetching player scores:", error);
            return { error: "An error occurred while fetching player data." };
        }
    };

    const handleCopyCode = (event) => {
        inputRef.current.select();
        document.execCommand('copy');
        inputRef.current.setSelectionRange(0, 0);
    };

    return (
        <div className='wrapper h-100'>
            {loading ?
                <div className="loader">
                    <Oval color="#daff00" secondaryColor="#ffffff" strokeWidth={3} strokeWidthSecondary={3} height={50} width={50} />
                </div>
                : ""}
            <BackButton label={t('Home')} closeFunction={() => navigate(`/${HOME}`)} />
            <div className='buddy_tournament_wrapper'>
                <h3 className='fw-bold mt-3 text-white opacity-75'>{t('Buddy Tournament')}</h3>
                <p className='mb-0 pb-2 text-white opacity-50'>The standard Lorem Ipsum passage, used since the 1500s <br /> "Lorem ipsum dolor sit amet, consectetur adipiscing elit, The standard Ipsum passage, used since the 1500s</p>
                <div className='mt-4 mb-3 position-relative'>
                    <input type='text' className='w-100 text-light px-3' id='buddyId' name='BuddyId' placeholder={t('Your buddy ID')} value={buddyCode} ref={inputRef} readOnly />
                    <span className='bg-info copy position-absolute rounded-circle'>
                        <IoMdCopy size={18} className='text-white' onClick={handleCopyCode} />
                    </span>
                </div>
            </div>
            {/* GAME RESULT */}
            <div className='lobby_wrapper'>
                <h3 className='text-white fw-bold mb-3 text-white opacity-75'>{t('Lobby Members')}</h3>
                <div className='members_list px-4 py-3'>
                    {users.map((user, index) => {
                        return (
                            <div key={user._id} className={`item d-flex align-items-center gap-2`}>
                                <div className='member_profile rounded-circle position-relative'>
                                    <h6 className='text-white mb-0'>{user.user !== null ? user.name.split(" ").slice(0, 2).map(word => word[0].toUpperCase()).join("") : 'P'}</h6>
                                </div>
                                <p className='mb-0 text-white user_name'>{user.name ? user.name : 'Player_' + index}</p>
                                <div className='d-flex justify-content-between align-items-center w-100'>
                                    <p className={`mb-0 user_status opacity-75 ${user.userStatus === 'Playing' ? 'text-warning' : ''}`}>
                                        {(user.status === 'Playing' || user.status === 'Completed') ? user.burnedCal : user.userStatus}
                                    </p>
                                    <div className={`d-flex align-items-center justify-content-center gap-1 game_status rounded-corners w-auto px-2 ${(user.status == 'Waiting') ? 'waiting' : ''}`}>
                                        {(user.status !== 'Waiting') ? <span className='rounded-circle'>< FaCheck /></span> : null}
                                        <p className='mb-0'>{(user.status == 'Waiting') ? t('Waiting...') : t(user.status)}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>

                <input type='hidden' id='gameTitle' value={gameTitle} />
                {!userGameIsCompleted && !users.some(user => user.status === 'Playing') ? (
                    <button
                        type='button'
                        className='mx-auto mt-4 cta_button d-flex align-items-center justify-content-center position-relative border-0 bg-warning'
                        onClick={handleReady}
                    >
                        <span className='fw-bold'>{t('Ready')}</span>
                    </button>
                ) : <button
                    type='button'
                    className='mx-auto mt-4 cta_button d-flex align-items-center justify-content-center position-relative border-0 bg-warning'
                    onClick={handleGoBurn}
                    disabled={
                        playersCount < 3 ||
                        (userType === 'guest_user'
                            ? !users.some(user => user._id === playerId && user.status === 'Ready')
                            : !users.some(user => user.user === userData?._id && user.status === 'Ready')) ||
                        (userType === 'guest_user'
                            ? users.some(user => user._id === playerId && user.status === 'Completed')
                            : users.some(user => user.user === userData?._id && user.status === 'Completed')) ||
                        buddyComplete
                    }
                    >
                    <span className='fw-bold text-dark'>{t('Go Burn Calories')}</span>
                    <GrFormNext size={20} />
                </button>}
                <p className='mb-0 mt-4 pt-2 text-warning text-center'>
                    {(playersCount === true) ? t('Waiting for result...') : (playersCount < 3) ? t('Waiting for players to join...') : ''}
                </p>
                <p className='mb-0 mt-4 pt-2 text-warning text-center'>
                    {(isWaiting === true) ? t('Waiting for other players to finish the game......') : ''}
                </p>
                
                {buddyCode && (
                    <VoiceChat
                        roomId={buddyCode}
                        userId={userType === 'guest_user' ? playerId : userData?._id}
                    />
                )}
            </div>

            <div className={`modal ${isCompleted ? 'show' : ''}`} style={{ display: isCompleted ? 'block' : 'none' }}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className='members_list px-4 py-3'>
                        {
                            users.map((user, index) => {
                                return (
                                    <div key={user._id} className={`item d-flex align-items-center gap-2 ${user.isWinner ? 'toper_user' : ''}`}>
                                        <p className='mb-0 text-white user_name'>{user.name}</p>
                                        <p className='mb-0 ms-auto user_status'>{user.burnedCal}</p>
                                        {user.isWinner && <FaCrown className="position-absolute" />}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>

            {isCompleted && (
                <div className="modal-backdrop show"></div>
            )}

        </div>
    );
}

export default BuddyTournamentJoin;